import APIService from '../api';
import { User } from './SigninTypes';
import {
  openCentralizedPopupWindow,
  onSigninPopupCloseRedirect
} from '@/utils/windowPopup';
import { insideProviderIframe } from '@/utils/providerIframe';
import { isCrossSiteEmbed } from '@/utils/remote-loading';

export const SOCIAL_LOGIN_REDIRECT_KEY = '@twism:social-redirect';

export default class SignIn extends APIService {
  async login(password: string, mail: string, authType: string) {
    const response = await this.post(
      '/auth/signin',
      new User(mail, password, authType),
      {
        withCredentials: true
      }
    );
    // TWISM-18411: inside a cross-site provider embed the browser rejects the
    // SameSite=Lax Set-Cookie of this response, so retain the JWT from the
    // body and authenticate via Bearer instead. sessionStorage survives the
    // full-page reload Login.vue does right after this resolves.
    if (isCrossSiteEmbed() && response.data && response.data.access_token) {
      APIService.setEmbedToken(response.data.access_token);
    }
    return response;
  }

  loginWithProvider(
    provider: 'google' | 'apple',
    invitationData?: Record<string, string>
  ) {
    const url = `${this.host()}/auth/${provider}/authUrl/signin`;

    if (invitationData && invitationData.hasOwnProperty('redirect')) {
      localStorage.setItem(
        SOCIAL_LOGIN_REDIRECT_KEY,
        JSON.stringify(invitationData)
      );
    }

    if (insideProviderIframe()) {
      const newWindow = (openCentralizedPopupWindow(
        url,
        `${provider} Connect`,
        450,
        600
      ) as unknown) as Window;

      onSigninPopupCloseRedirect(newWindow);
    } else {
      location.href = url;
    }
  }
}
